import { api } from './api';
import { Me } from '../types/Auth';

/** Fetch the authenticated staff member's role, effective permissions and scope. */
export const getMe = (): Promise<Me> => api.get('/admin/me').then((r) => r.data);
